module.exports = __webpack_public_path__ + "fee17bd99b0fe40f46de5212ed344137.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/projekte/festival06.jpg
// module id = 656
// module chunks = 0